/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Directory_Resources_Newsletter_EyebrowInputs */

const en_directory_resources_newsletter_eyebrow = /** @type {(inputs: Directory_Resources_Newsletter_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter`)
};

const zh_directory_resources_newsletter_eyebrow = /** @type {(inputs: Directory_Resources_Newsletter_EyebrowInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Newsletter`)
};

/**
* | output |
* | --- |
* | "Newsletter" |
*
* @param {Directory_Resources_Newsletter_EyebrowInputs} inputs
* @param {{ locale?: "en" | "zh" }} options
* @returns {LocalizedString}
*/
const directory_resources_newsletter_eyebrow = /** @type {((inputs?: Directory_Resources_Newsletter_EyebrowInputs, options?: { locale?: "en" | "zh" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Directory_Resources_Newsletter_EyebrowInputs, { locale?: "en" | "zh" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_directory_resources_newsletter_eyebrow(inputs)
	return zh_directory_resources_newsletter_eyebrow(inputs)
});
export { directory_resources_newsletter_eyebrow as "directory.resources.newsletter.eyebrow" }